import type {
    OrganizationStatus,
    OrganizationStatusHistoryEntry,
} from "@models/organization";
import { StatusTimeline } from "@admin/_components/StatusTimeline";
import { STATUS_META } from "./status";

interface StatusHistoryProps {
    history: OrganizationStatusHistoryEntry[];
}

// Read through a partial view: a history row can carry a value this build
// has no label for (review finding 7), and the timeline falls back for it.
const STATUS_LABELS: Partial<Record<number, { label: string }>> = STATUS_META;
const labelOf = (status: OrganizationStatus) => STATUS_LABELS[status]?.label;

// The client's status changes (#460 / AO-09: the cancel reason must be
// readable), in the API's order, newest first. Who made a change is left
// out: the response carries a bare user id, which means nothing to an admin.
export const StatusHistory = ({ history }: StatusHistoryProps) => (
    <StatusTimeline
        entries={history.map((entry) => ({ ...entry, note: entry.reason }))}
        labelOf={labelOf}
        missingNote="No reason given"
    />
);
